import { networksIndex } from "./networksIndex.mjs";
import { ref, useRequestURL } from "#imports";
const defaultOptions = {
  network: "",
  url: void 0,
  title: void 0,
  user: void 0,
  hashtags: void 0,
  image: void 0
};
export function useSocialShare(options = defaultOptions) {
  const { network, url, title, user, hashtags, image } = options;
  const selectedNework = ref({ ...networksIndex[network] });
  const pageUrl = url !== void 0 ? url : useRequestURL().href;
  const shareUrl = selectedNework.value.shareUrl;
  const argTitle = selectedNework.value.args?.title && title ? selectedNework.value.args?.title : "";
  const argUser = selectedNework.value.args?.user && user ? selectedNework.value.args?.user : "";
  const argHashtags = selectedNework.value.args?.hashtags && hashtags ? selectedNework.value.args?.hashtags : "";
  const argImage = selectedNework.value.args?.image && image ? selectedNework.value.args?.image : "";
  let fullUrl = shareUrl + argTitle + argUser + argHashtags + argImage;
  fullUrl = fullUrl.replace(/\[u\]/i, pageUrl).replace(/\[t\]/i, title || "").replace(/\[uid\]/i, user || "").replace(/\[h\]/i, hashtags || "").replace(/\[i\]/i, image || "");
  selectedNework.value.shareUrl = fullUrl;
  delete selectedNework.value.args;
  return selectedNework;
}
